duracion_min: 30
faseProduccion: 0
id: 1
preguntas: 3
secciones:
- tipo: teoria
- tipo: quiz-practica
- tipo: recursos
titulo: Hablar de dinero
